/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the CategorisationNode interface.
 */
export function instanceOfCategorisationNode(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "nodeType" in value;
    return isInstance;
}
export function CategorisationNodeFromJSON(json) {
    return CategorisationNodeFromJSONTyped(json, false);
}
export function CategorisationNodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'children': !exists(json, 'children') ? undefined : (json['children'].map(CategorisationNodeFromJSON)),
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'nodeType': json['node_type'],
        'parameter': !exists(json, 'parameter') ? undefined : json['parameter'],
        'threshold': !exists(json, 'threshold') ? undefined : json['threshold'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function CategorisationNodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'children': value.children === undefined ? undefined : (value.children.map(CategorisationNodeToJSON)),
        'id': value.id,
        'label': value.label,
        'node_type': value.nodeType,
        'parameter': value.parameter,
        'threshold': value.threshold,
        'value': value.value,
    };
}
